function getCaseInsensitiveMatch(obj, keyToMatch) {
    obj = obj || {};
    const key = Object.keys(obj).find(key => key.toLowerCase() === keyToMatch.toLowerCase());
    return key ? obj[key] : null;
}
/**
 * @memberof geodata
 * @param {customer-metadata.UserLayer} layer
 * @param {GeoJSON.Feature} feature
 * @param {number} featureIndex
 * @return {string}
 */
function getFeatureLabel(layer, feature, featureIndex) {
    let label = '';
    if (layer.featureLabelField && feature.properties) {
        label = feature.properties[layer.featureLabelField] || '';
    }
    if (!label) {
        const recognizedLabels = [
            getCaseInsensitiveMatch(feature.properties, 'label'),
            getCaseInsensitiveMatch(feature.properties, 'name'),
            getCaseInsensitiveMatch(feature.properties, 'label_long'),
            getCaseInsensitiveMatch(feature.properties, 'label_short'),
        ];
        // Single layer features without an explicit label (such as drawn features) should take on the layer name.
        const { featureCount } = layer;
        const actualFeatureCount = layer.geom && layer.geom.features.length;
        if (featureCount === 1 || actualFeatureCount === 1) {
            recognizedLabels.push(layer.friendlyName);
        }
        recognizedLabels.push(`Unlabeled geography ${featureIndex + 1} in ${layer.friendlyName}`);
        label = recognizedLabels.find(v => v);
    }
    return label;
}
export default getFeatureLabel;
